/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExpiryPeriod,
    ExpiryPeriodFromJSON,
    ExpiryPeriodFromJSONTyped,
    ExpiryPeriodToJSON,
} from './ExpiryPeriod';
import {
    SessionPackageObjectType,
    SessionPackageObjectTypeFromJSON,
    SessionPackageObjectTypeFromJSONTyped,
    SessionPackageObjectTypeToJSON,
} from './SessionPackageObjectType';
import {
    Subtotal,
    SubtotalFromJSON,
    SubtotalFromJSONTyped,
    SubtotalToJSON,
} from './Subtotal';

/**
 * 
 * @export
 * @interface SessionPackage
 */
export interface SessionPackage {
    /**
     * 
     * @type {string}
     * @memberof SessionPackage
     */
    id: string;
    /**
     * 
     * @type {SessionPackageObjectType}
     * @memberof SessionPackage
     */
    object: SessionPackageObjectType;
    /**
     * 
     * @type {string}
     * @memberof SessionPackage
     */
    name: string;
    /**
     * 
     * @type {Subtotal}
     * @memberof SessionPackage
     */
    price: Subtotal;
    /**
     * 
     * @type {boolean}
     * @memberof SessionPackage
     */
    is_discontinued: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SessionPackage
     */
    include_fee: boolean;
    /**
     * 
     * @type {number}
     * @memberof SessionPackage
     */
    allocated_amount: number;
    /**
     * 
     * @type {string}
     * @memberof SessionPackage
     */
    terms?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionPackage
     */
    program_id: string;
    /**
     * 
     * @type {number}
     * @memberof SessionPackage
     */
    expiry_amount?: number;
    /**
     * 
     * @type {ExpiryPeriod}
     * @memberof SessionPackage
     */
    expiry_period: ExpiryPeriod;
    /**
     * 
     * @type {Date}
     * @memberof SessionPackage
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SessionPackage
     */
    updated?: Date;
}

export function SessionPackageFromJSON(json: any): SessionPackage {
    return SessionPackageFromJSONTyped(json, false);
}

export function SessionPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionPackage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': SessionPackageObjectTypeFromJSON(json['object']),
        'name': json['name'],
        'price': SubtotalFromJSON(json['price']),
        'is_discontinued': json['is_discontinued'],
        'include_fee': json['include_fee'],
        'allocated_amount': json['allocated_amount'],
        'terms': !exists(json, 'terms') ? undefined : json['terms'],
        'program_id': json['program_id'],
        'expiry_amount': !exists(json, 'expiry_amount') ? undefined : json['expiry_amount'],
        'expiry_period': ExpiryPeriodFromJSON(json['expiry_period']),
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
    };
}

export function SessionPackageToJSON(value?: SessionPackage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': SessionPackageObjectTypeToJSON(value.object),
        'name': value.name,
        'price': SubtotalToJSON(value.price),
        'is_discontinued': value.is_discontinued,
        'include_fee': value.include_fee,
        'allocated_amount': value.allocated_amount,
        'terms': value.terms,
        'program_id': value.program_id,
        'expiry_amount': value.expiry_amount,
        'expiry_period': ExpiryPeriodToJSON(value.expiry_period),
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
    };
}

